"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));

require("cross-fetch/polyfill");

var _config = _interopRequireDefault(require("../config/config.json"));

var _configOptions = require("../constants/config-options");

var _formatter = _interopRequireDefault(require("../lib/formatter"));

var _log = _interopRequireDefault(require("../lib/log"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var minimumStatement = {
  actor: {
    account: {
      homePage: 'not-set',
      name: 'not-set'
    }
  },
  verb: {
    id: 'not-set',
    display: {
      'en-US': 'not-set'
    }
  },
  object: {
    id: 'not-set',
    objectType: 'Activity'
  }
};
/**
 * Build and return IRI for an xAPI statement element.
 *
 * @param {String} type The type of the element like, 'verb' or 'extensions/object'.
 * @param {String} value
 * @return {String} Formatted IRI.
 */

function getIri(type, value) {
  return "https://api.amplify.com/xapi/".concat(type, "s/").concat(value);
}
/**
 * Wrapper around Amplify event endpoint that
 * generates events in the xAPI format.
 * 8/15/2017 - Mike Z. first version based on
 * amp-event lib: https://github.com/amplify-education/amp-event
 */


var xApiStatementFactory = /*#__PURE__*/function () {
  function xApiStatementFactory(options, environment) {
    _classCallCheck(this, xApiStatementFactory);

    this.options = options;
    this.environment = environment;

    if (Object.values(xApiStatementFactory.ENVIRONMENT).includes(environment)) {
      this.events_url = _config["default"][environment].events_url;
    }
  }

  _createClass(xApiStatementFactory, [{
    key: "create",
    value: function create() {
      var _this = this;

      /** ****************
       * Base statement *
       ******************/
      var event = {
        statement: (0, _cloneDeep2["default"])(minimumStatement)
      };
      /** ********************************
       * xApiStatement Builder Settings *
       **********************************/

      event.addActor = function (key, value) {
        event.statement.actor[key] = value;
        return event;
      };

      event.addActorAccount = function (key, value) {
        event.statement.actor.account[key] = value;
        return event;
      };

      event.addVerb = function (key, value) {
        event.statement.verb[key] = value;
        return event;
      };

      event.addVerbId = function (id) {
        event.statement.verb.id = getIri('verb', id);
        return event;
      };

      event.addObject = function (key, value) {
        event.statement.object[key] = value;
        return event;
      };

      event.addObjectId = function (id) {
        event.statement.object.id = id.startsWith('https://') ? id : getIri('object', id);
        return event;
      };

      event.addObjectExtension = function (key, value) {
        if (!event.statement.object.definition) {
          event.statement.object.definition = {
            extensions: {}
          };
        }

        if (!event.statement.object.definition.extensions) {
          event.statement.object.definition.extensions = {};
        }

        event.statement.object.definition.extensions[getIri('extensions/object', key)] = value;
        return event;
      };

      event.addObjectDefinition = function (key, value) {
        if (!event.statement.object.definition) {
          event.statement.object.definition = {};
        }

        event.statement.object.definition[key] = value;
        return event;
      };

      event.addResult = function (key, value) {
        if (!event.statement.result) {
          event.statement.result = {};
        }

        event.statement.result[key] = value;
        return event;
      };

      event.addResultExtension = function (key, value) {
        if (!event.statement.result) {
          event.statement.result = {};
        }

        if (!event.statement.result.extensions) {
          event.statement.result.extensions = {};
        }

        event.statement.result.extensions[getIri('extensions/result', key)] = value;
        return event;
      };

      event.addContext = function (key, value) {
        if (!event.statement.context) {
          event.statement.context = {};
        }

        event.statement.context[key] = value;
        return event;
      };

      event.addContextExtension = function (key, value) {
        if (!event.statement.context) {
          event.statement.context = {};
        }

        if (!event.statement.context.extensions) {
          event.statement.context.extensions = {};
        }

        event.statement.context.extensions[getIri('extensions/context', key)] = value;
        return event;
      };

      event.setTimestamp = function (value) {
        event.statement.timestamp = value;
        return event;
      };

      event.setStored = function (value) {
        event.statement.stored = value;
        return event;
      };

      event.addAuthority = function (key, value) {
        event.statement.authority[key] = value;
        return event;
      };
      /** ***************
       * Apply options *
       *****************/
      // Add library version to every statement.


      event.addContextExtension('library-version', xApiStatementFactory.API_VERSION);

      if (this.options.appVersion) {
        event.addContext('revision', this.options.appVersion);
      }

      if (this.options.appName) {
        event.addContext('platform', this.options.appName);
      }

      if (this.options.language) {
        event.addContext('language', this.options.language);
      }

      if (this.environment && this.events_url) {
        event.addContextExtension('environment', this.environment);
      }

      if (this.options.homePage) {
        event.addActorAccount('homePage', this.options.homePage);
      }

      event.emit = function () {
        return _this.emit(event.statement);
      };

      return event;
    } // Emit event

  }, {
    key: "emit",
    value: function emit(statement) {
      var _this2 = this;

      var _statement = _formatter["default"].formatStatement(statement); // Add timestamp if it is not already set.


      _statement.timestamp = _statement.timestamp && _statement.timestamp !== '' ? _statement.timestamp : new Date().toISOString();
      return new Promise(function (resolve, reject) {
        if (_this2.environment && _this2.events_url) {
          fetch(_this2.events_url, {
            priority: 'low',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(_statement)
          }).then(function () {
            _log["default"].debug("Event send success::: ".concat(JSON.stringify(_statement, null, 2)));

            resolve();
          })["catch"](function (error) {
            _log["default"].error("Event send error::: ".concat(error));

            reject(error);
          });
        } else {
          _log["default"].error("Unable to send event::: environment=".concat(_this2.environment, ", url:").concat(_this2.events_url));

          reject('Error sending event');
        }
      });
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(language) {
      this.options.language = language;
    }
  }, {
    key: "setHomePage",
    value: function setHomePage(homePage) {
      this.options.homePage = homePage;
    }
  }]);

  return xApiStatementFactory;
}(); // Echo's the current lib version, based on package.json.


xApiStatementFactory.API_VERSION = "4.1.14";
xApiStatementFactory.ENVIRONMENT = _configOptions.ENVIRONMENTS; // Options available to StatementTemplate.

xApiStatementFactory.OPTIONS = {
  APP_NAME: 'appName',
  APP_VERSION: 'appVersion',
  LANGUAGE: 'language'
};
var _default = xApiStatementFactory;
exports["default"] = _default;
module.exports = exports.default;